export enum SessionActionTypes {
    THANKYOU_PAGE_CTA_CLICK = 'thankyou_page_cta_click',
}
